var _defs, _tspan, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTs98(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "38.124077mm",
    height: "97.174316mm",
    viewBox: "0 0 38.124077 97.174316",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-199.82569)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uF5F2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "text108",
    transform: "matrix(0.99999797,0,0,0.99999797,-1.9242446,1.4265902)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 32.110882,267.19135 c 3.487699,-2.16477 5.772743,-5.41194 5.772743,-10.22256 0,-9.7415 -14.071061,-11.18469 -16.716901,-11.18469 -11.1846889,0 -18.7614136,5.05115 -18.7614136,13.10894 0,6.73486 3.7282296,10.22256 8.4185826,12.8684 -5.0511494,2.40531 -8.8996445,5.53221 -8.8996445,11.66575 0,8.29832 8.6591135,12.14682 18.1600865,12.14682 9.621238,0 19.964068,-4.08903 19.964068,-17.0777 0,-5.77274 -3.367433,-9.01991 -7.937521,-11.30496 z M 19.723538,292.4471 c -6.494335,0 -12.2670778,-3.24716 -12.2670778,-9.50097 0,-3.84849 3.3674328,-7.45646 7.5767248,-9.14017 6.975397,3.1269 14.07106,5.17141 14.07106,11.54548 0,3.8485 -2.886371,7.09566 -9.380707,7.09566 z m 7.45646,-27.42052 c -7.696991,-2.76611 -15.875043,-4.32956 -15.875043,-10.4631 0,-3.96876 5.411947,-6.01327 9.621238,-6.01327 3.126902,0 11.304955,1.56345 11.304955,8.29831 0,3.8485 -1.924248,6.37407 -5.05115,8.17806 z M 16.716902,231.95357 c -1.08239,-1.08239 -2.766106,-1.56345 -4.329557,-1.56345 -0.721593,0 -1.563452,0.12026 -2.4053099,0.3608 -3.0066368,0.72159 -5.2916808,3.84849 -5.2916808,6.97539 0,0.3608 0,0.60133 0.1202655,0.96213 0.4810619,3.24716 3.1269023,5.53221 6.0132732,6.6146 2.40531,0.96212 5.171416,1.20265 7.696991,1.20265 7.215928,-0.12026 14.07106,-3.60796 17.558759,-10.22256 2.164778,-3.96876 3.728229,-9.14018 3.728229,-13.59 v -0.3608 c -0.120265,-4.44982 -0.841858,-9.50097 -3.006637,-13.34946 -1.924247,-3.60797 -5.29168,-7.57673 -9.01991,-9.26045 -2.405309,-0.96212 -5.291681,-1.32292 -7.69699,-1.32292 -4.329557,0 -9.140176,0.7216 -12.6278748,3.4877 -3.3674332,2.64584 -5.5322117,6.9754 -5.5322117,11.30496 0,5.41194 2.8863713,8.65911 6.0132736,11.06442 2.5255749,1.92425 5.5322119,2.88637 8.5388489,2.88637 3.006636,0 6.253804,-1.08239 8.779379,-3.36743 0.120266,-0.12027 0.360797,-0.12027 0.481062,-0.12027 0.601327,0 0.962124,0.7216 0.962124,2.28505 -0.360797,17.79929 -6.013274,18.28035 -8.057787,18.28035 -1.924247,0 -3.126902,-0.48106 -3.126902,-1.44319 0,-1.32292 1.803982,-2.52557 2.405309,-3.60796 0.481062,-0.96212 0.601328,-1.92425 0.601328,-2.88637 0,-1.44319 -0.481062,-2.88637 -1.443186,-3.8485 0,-0.24053 -0.240531,-0.36079 -0.360796,-0.48106 z m 3.728229,-9.38071 c -3.126902,0 -5.772742,-4.81062 -5.772742,-10.82389 0,-5.89301 2.64584,-10.70363 5.772742,-10.70363 3.006637,0 5.532212,4.81062 5.532212,10.70363 0,6.01327 -2.525575,10.82389 -5.532212,10.82389 z",
    id: "path4609"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs98);
export default __webpack_public_path__ + "static/media/ts-9-8.ee208c507afd0f5e51eacd579f1589d0.svg";
export { ForwardRef as ReactComponent };